module.exports = __webpack_public_path__ + "static/media/jasmine_stoy.58d6b930.jpeg";